const E = {
  selectRegion: '-- Select a Region --',
};

const F = {
  selectRegion: '-- Sélectionnez une région --',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/regions.js